module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQI12NgYGBYDAAAqACkxaGYIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/fancybox-plus/images/fbplus/fbplus_title_over.png
// module id = 932
// module chunks = 0